import { render, staticRenderFns } from "./ServiceOrderPage.vue?vue&type=template&id=2cb45344&"
import script from "./ServiceOrderPage.vue?vue&type=script&lang=js&"
export * from "./ServiceOrderPage.vue?vue&type=script&lang=js&"
import style0 from "./ServiceOrderPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports